export default __webpack_public_path__ + "dc2cbadd690e1d4b2c9c11c8143d027c.woff";